<template>
  <div>
    <b-nav-item-dropdown
      right
      class="notification-list align-self-center profile-dropdown"
      toggle-class="nav-user mr-0"
    >
      <template v-slot:button-content>
        <div class="media user-profile btn2 btn2-tertiary">
          <div class="media-body text-left">
            <h6 class="pro-user-name ml-2 my-0 text-muted">
              CREATE NEW
            </h6>
          </div>
          <feather
            type="chevron-down"
            class="ml-2 align-self-center icon-xs text-muted"
          ></feather>
        </div>
      </template>
      <b-dropdown-item href="javascript:void(0);" class="notify-item p-0"
        v-for="(item, idx) in dropdownList"
        :key="idx"
        @click="onClickActions({method: `create${item.name}`, type: 'ref', isEdit: false})"
      >
        <div class="d-flex align-items-center">
          <feather :type="item.icon" class="icon-dual icon-xs mr-2"></feather>
          <span v-if="item.label">{{ $t(`${item.label}`) }}</span>
          <span v-else>{{ item.name }}</span>
        </div>
      </b-dropdown-item>
    </b-nav-item-dropdown>
    
    <Dialog
      title="View Candidate"
      centered
      ref="viewCandidate"
      size="xl"
      bodyClass="modalBodyContainer px-4"
      :component="viewCandidateComponent"
      :parameters="{ candidateID }"
      @onClick="onClickActions"
    />

    <Dialog
      size="lg"
      ref="createCandidate"
      :title="`${candidateID ? 'Edit Candidate' : 'Apply with New Candidate'}`"
      :component="createCandidateComponent"
      @onClick="onCreateCandidate"
      :parameters="{ candidateID }"
    />

    <Dialog
      customBtnClass="component-job"
      ref="createJob"
      title="Create Job"
      size="lg"
      yesText="Submit"
      noText="Cancel"
      :buttonDisable="created"
      :component="computedCreateJobComponent"
      @onYes="onCreateJob"
      @onPreview="onPreview"
    />

    <Dialog
      customBtnClass="component-custom"
      is_reset_model
      title="Create Company"
      size="xl"
      ref="createCompany"
      yesText="Create"
      noText="Cancel"
      :buttonDisable="created"
      :parameters="{ submitted }"
      :component="computedCreateCompanyComponent"
      @onYes="onCreateCompany"
    />

    <Dialog
      title="Preview Job"
      ref="previewJob"
      bodyClass="modalBodyContainer px-4"
      size="xl"
      :component="computedViewJobComponent"
      :parameters="{ previewData, submitted, hasNoSetting: true }"
    />
    
  </div>
</template>
<script>
import Dialog from './offcanvas'
import error from '@utils/error'
import { EventBus } from '../event-bus'

export default {
  components: { Dialog },
  computed: {
    computedCreateJobComponent() {
      return () => import('@pages/job/components/dialogs/create.vue')
    },
    computedCreateCompanyComponent() {
      return () => import('@pages/company/components/dialogs/create.vue')
    },
    computedViewJobComponent() {
      return () => import('@pages/job/components/dialogs/view.vue')
    },
    createCandidateComponent() {
      return () => import('@pages/job/components/dialogs/createCandidate.vue')
    },
    viewCandidateComponent() {
      return () => import('@pages/candidate/components/dialogs/view.vue')
    },
  },
  props: {
    dropdownList: Array
  },
  data() {
    return {
      created: false,
      previewData: {},
      submitted: false,
      hasCustomLayout:true,
      candidateID: ''
    }
  },
  methods: {
    async onCreateCandidate(val) {
      EventBus.$emit('onFetchCandidateData')
      if(val.isCreated){
        this.$bvToast.toast(`Candidate successfully ${this.candidateID ? 'updated' : 'created'}!`, {
          title: "Notification",
          variant: "success"
        })
      }
      this.onCloseModal(val)

      if(this.candidateID) {
        await this.$refs.viewCandidate.hide()
      }

      if(val.candidateID) {
        this.openFormBar(val.candidateID)
      }
		},
		onCreateJob(val) {
      this.created = true;
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      
      val.validateForm && val.validateForm();
      if (val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      }

      model.city = model.city.text

      return this.$store.dispatch('job/create', { ...model })
      .then(res => {  
        EventBus.$emit('onFetchJobData')
        if (res && res.data) {
          let { data } = res

          this.$refs.createJob.hide();
          this.$refs.list.fetchData();
          this.$bvToast.toast(`${data.job.title} successfully added!`, {
            title: "Notification",
            variant: "success" 
          });

          setTimeout(() => {
            this.created = false;
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast)
      })
		},
		onCreateCompany(val) {
			this.created = true
      let model = val && val.model && Object.entries(val.model).length ? val.model : val
      const objParam = ['industry_id', 'function_id', 'rate', 'source_company']

      val.validateForm && val.validateForm()
      if (val.$v && val.$v.$error) {
        this.created = false;
        return error.errorHandler({ message: "Required field(s) must not be empty" }, this.$bvToast)
      } else {
        model.brand_id = model && typeof model.brand_id == 'object' ? model.brand_id._id : model.brand_id
        model.timezone_id = model && typeof model.timezone_id == 'object' ? model.timezone_id._id : model.timezone_id
      }

      
      if (model && model.avatar_path) {
        let data = { ...model }
        model = new FormData()

        for (let key in data) {
          if (objParam.includes(key)) model.append(key, JSON.stringify(data[key]))
          else model.append(key, data[key])
        }
      }

      return this.$store.dispatch('company/create', model)
      .then(result => {
        EventBus.$emit('onFetchCompanyData')
        if (result && result.data) {
          this.submitted = !this.submitted
          this.$refs.createCompany.hide()
          this.$refs.list.fetchData()
          this.$bvToast.toast(`${result.data.name} successfully created!`, {
            title: "Notification",
            variant: "success"
          })
          setTimeout(() => {
            this.created = false
          }, 1500)
        }
      })
      .catch(err => {
        this.created = false;
        return error.errorHandler(err, this.$bvToast);
      })
		},
    onPreview(previewData) {
      this.previewData = previewData
      this.$refs.previewJob.show()
    },
    onCloseModal(val){
      this.$refs[val.bool].hide()
    },
    onClickActions(val) {
      this.candidateID = ''
      if (val && Object.entries(val).length) {
        if (val.type && val.type.toLowerCase() == 'function') {
          this[val.method](val.data)
        }
        else if (val.type && val.type.toLowerCase() == 'ref') {
          let isEdit = !!val.isEdit
          if(isEdit) {
            this.openFormBar(val.data._id, isEdit)
          } else {
            this.$refs[val.method].show()
          }
        }
      }
    },
    openFormBar(id, editMode = false) {
      this.candidateID = id
      if (!editMode) {
        this.$refs.viewCandidate.show()
      } else {
        this.$refs.createCandidate.show()
      }
    },
  }
}
</script>